/**
 * Api error codes that are reported by the Recorder controller
 */
export var RecorderErrorCode;
(function (RecorderErrorCode) {
    /**
     * Indicates an attempt to create a Recorder that violates uniqueness constraints within a Court System
     */
    RecorderErrorCode["RecorderAlreadyExists"] = "recorder/RecorderAlreadyExists";
    /**
     * A Recorder was not found
     */
    RecorderErrorCode["RecorderNotFound"] = "recorder/RecorderNotFound";
    /**
     * Indicates an attempt to unlink a Recorder that has dependent data within a Court System
     */
    RecorderErrorCode["DependenciesExist"] = "recorder/DependenciesExist";
    /**
     * When creating a recorder no location or department was specified.
     */
    RecorderErrorCode["RecorderCouldNotBeCreated"] = "recorder/RecorderCouldNotBeCreated";
})(RecorderErrorCode || (RecorderErrorCode = {}));
